// user Initial Values Formik

export const initialStatementValues = {
  statement: '',
  visibility: 0,
  folderIdArray: [],
  companyArray: []
};
